import { breakpointUp } from '../helpers/breakpoints'
import { updateLocoScroll, startLocoScroll} from '../locomotive-scroll'
import { openPopup } from '../popups'

let globalHash = window.location.hash
export function setUpNavigation(locoScroll) {
  let toHash = $('.js-go-to')

  if (globalHash) {

    goToHash(globalHash)

    if (!breakpointUp('lg')){
      $('body, html').removeClass('modal-open')
    }
    // setTimeout(function(){
    //   $('.on-video-container').hide()
    // }, 400)
  }


  // go to hash
  toHash.click(function (e) {
    e.preventDefault()
    let goTo = '#' + $(this).data('go-to')
    goToHash(goTo)

    if (window.innerWidth < 1000)
      $('.js-open-close-menu').click()
  })


  // Set active menu el
  if (breakpointUp('lg')) {

    locoScroll.on('scroll', (data) => {
      if (data.currentElements){
        let lastActiveEl = 0

        if ($('#content-block').offset().top < 0) {
          $.each(data.currentElements, function () {
            if ($(this.el).hasClass('js-nav-block'))
              lastActiveEl = $(this.el)
          })

          if (lastActiveEl !== 0)
            setActiveElement(lastActiveEl)
        }
      }
    });

  } else {

    $(window).bind('scroll', function () {
      let currentTop = $(window).scrollTop()
      let navigationBlocks = $('.js-nav-block')

      navigationBlocks.each(function (index) {
        let elemTop = $(this).offset().top - 100
        if (currentTop >= elemTop) setActiveElement(this)
      })
    })

  } // end set active menu el


  let lastActive = ''
  function setActiveElement(el){
    let id = $(el).attr('id')
    if (lastActive !== id) {
      lastActive = id
      id = id.replace('block-', '')
      let navElem = $('[data-go-to="' + id + '"]')

      toHash.removeClass('js-active')
      navElem.addClass('js-active')
      setUrlHash(id)
    }
  }

  function goToHash (hash) {
    if (hash) {
      hash = hash.replace('#', '')
      hash = hash.replace('/', '')
      let hashEl = ''
      let isPopup = 0

      if (hash.search('popup-') !== -1){
        hashEl = hash.replace('popup-', '')
        isPopup = 1
      } else {
        hashEl = $('#block-' + hash)
      }

      if (hashEl.length) {
        if (isPopup){
          openPopup(hashEl, locoScroll)
        } else {
          if (breakpointUp('lg')) {
            startLocoScroll()
            locoScroll.scrollTo(hashEl[0], { duration: 600, callback: updateLocoScroll })
          } else {
            $('html, body').animate({ scrollTop: hashEl.offset().top })
          }
        }
      }
      //setUrlHash(hash)
    }
  }

}


let lastHistory = '';
let hashTimeout = 0;
export function setUrlHash (hash) {
  if (lastHistory !== hash && !hashTimeout) {
    lastHistory = hash
    if (window.history && window.history.pushState) {
      let curUrl = window.location.href.split(/[?#]/)[0]
      history.pushState({}, null, curUrl + '#' + hash)
      hashTimeout = 1
      setTimeout(function(){hashTimeout = 0}, 300)
    }
  }
}
